<template lang="pug">

  .new-user-promotion-form
    form(@submit.prevent="submit", @keydown="form.onKeydown($event)", :class="{ 'has-errors': form.errors.any() }")
      form-group-row.first-name-form-group(:form="form", :label="firstNameLabel", name="first_name", required)
        form-input(:form="form", name="first_name")
      form-group-row.email-form-group(:form="form", :label="emailLabel", name="email", required)
        form-input(:form="form", name="email", type="email")
      .form-group.submit-form-group
        v-button.btn-default(:loading="form.busy") {{ submitLabel }}

</template>

<script>
import Form from 'vform'
import { mapGetters } from 'vuex'

export default {
  name: 'new-user-promotion-form',

  props: {
    firstNameLabel: {
      type: String,
      default: 'First name'
    },
    emailLabel: {
      type: String,
      default: 'Email address'
    },
    submitLabel: {
      type: String,
      default: 'Submit'
    },
    onsubmit: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    form: new Form({
      first_name: '',
      email: '',
      visit: ''
    })
  }),

  methods: {
    async submit () {
      if (this.onsubmit.length) {
        eval(this.onsubmit);
      }

      this.form.visit = this.visit;

      const { data } = await this.form.post(`${window.addiesaas.url}/api/register/promotion`);

      if (data.error) {
        if (data.error == 'already_submitted') {
          this.$parent.$emit('already-submitted', this.form.email);
        }
      } else {
        this.$parent.$emit('just-submitted', this.form.email);
      }

      this.form.reset();
    }
  },

  computed: mapGetters({
    visit: 'visit'
  })
}
</script>
